import request from "@/utils/request";
import service from "@/utils/axios-v2";

/**
 * 用户添加或移除apikey接口
 *
 * @param {*} params
 * @returns
 */
export function eldApiKeyChange(params) {
  return service({
    url: "/fleet/integration/eld/apiKey/reAuthenticate",
    method: "get",
    params: params,
    headers: {
      "portal-token": true,
    },
  });
}

/**
 * 获取所有的eld的driver
 *
 * @returns
 */
export function eldDriverGet() {
  return service({
    url: "/fleet/integration/eld/drivers/get",
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}

/**
 * 获取匹配的信息
 *
 * @returns
 */
export function eldDriversMatchingGet() {
  return service({
    url: "/fleet/integration/eld/drivers/matchingInfo/get",
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}

/**
 * 获取map卡片信息
 */
export function eldTruckGet(params) {
  return service({
    url: "/fleet/integration/eld/truck/get",
    method: "post",
    headers: {
      "portal-token": true,
    },
    params,
  });
}

/**
 * 编辑Drivers信息
 * @param {*} params
 * @returns
 */
export function eldDriversEdit(params) {
  return service({
    url: "/fleet/integration/eld/drivers/edit",
    method: "post",
    headers: {
      "portal-token": true,
      "Content-Type": "application/json",
    },
    data: params,
  });
}

/**
 * eld拉取driver数据
 * @returns 
 */
export function eldRetriveApi() {
  return request({
    url: "/fleet/integration/retrive/api",
    method: "get",
    headers: {
      "portal-token": true
    }
  })
}

/**
 * 取消集成
 * @returns 
 */
export function eldApiKeyCancel() {
  return service({
    url: "/fleet/integration/eld/cancel_integration",
    method: "put",
    headers: {
      "portal-token": true
    }
  })
}

export function eldAssignVehicle(params) {
  return request({
    url: "/fleet/company/locationSource",
    method: "get",
    params,
    headers: {
      "portal-token": true
    }
  })
}

/**
 * 第三方登录后请求
 * @param {*} params 
 * @returns 
 */
export function oauthToken(params) {
  return request({
    url: "/fleet/v2/integration/eld/oauth/token",
    headers: {
      "portal-token": true
    },
    params
  })
}
